module.exports = global["jQuery"] = require("-!G:\\qinsujuan\\力图项目\\z正邦\\g高新科控\\gaoxinkekong\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");